import { render, staticRenderFns } from "./PetDetailOwnerPublic.vue?vue&type=template&id=62b45d60&scoped=true&"
import script from "./PetDetailOwnerPublic.vue?vue&type=script&lang=js&"
export * from "./PetDetailOwnerPublic.vue?vue&type=script&lang=js&"
import style0 from "./PetDetailOwnerPublic.vue?vue&type=style&index=0&id=62b45d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b45d60",
  null
  
)

export default component.exports